// src/types/properties/PropertyAmenity.ts
var PropertyAmenitySlug = /* @__PURE__ */ ((PropertyAmenitySlug2) => {
  PropertyAmenitySlug2["Wifi"] = "wifi";
  PropertyAmenitySlug2["TV"] = "tv";
  PropertyAmenitySlug2["Kitchen"] = "kitchen";
  PropertyAmenitySlug2["DedicatedWorkspace"] = "dedicated_workspace";
  PropertyAmenitySlug2["AC"] = "ac";
  PropertyAmenitySlug2["Heating"] = "heating";
  PropertyAmenitySlug2["Pool"] = "pool";
  PropertyAmenitySlug2["SharedPool"] = "shared_pool";
  PropertyAmenitySlug2["HotTub"] = "hot_tub";
  PropertyAmenitySlug2["Gym"] = "gym";
  PropertyAmenitySlug2["Washer"] = "washer";
  PropertyAmenitySlug2["Dryer"] = "dryer";
  PropertyAmenitySlug2["OnSiteParking"] = "on_site_parking";
  PropertyAmenitySlug2["StreetParking"] = "street_parking";
  PropertyAmenitySlug2["Safe"] = "safe";
  PropertyAmenitySlug2["Lockbox"] = "lockbox";
  PropertyAmenitySlug2["SelfCheckIn"] = "self_check_in";
  PropertyAmenitySlug2["LuggageDropOff"] = "luggage_drop_off";
  PropertyAmenitySlug2["LongTermStays"] = "long_term_stays";
  PropertyAmenitySlug2["BeachView"] = "beach_view";
  PropertyAmenitySlug2["PoolView"] = "pool_view";
  PropertyAmenitySlug2["CityView"] = "city_view";
  PropertyAmenitySlug2["SeaView"] = "sea_view";
  PropertyAmenitySlug2["LagoonView"] = "lagoon_view";
  PropertyAmenitySlug2["GardenView"] = "garden_view";
  PropertyAmenitySlug2["NileView"] = "nile_view";
  PropertyAmenitySlug2["LakeView"] = "lake_view";
  PropertyAmenitySlug2["BeachAccess"] = "beach_access";
  PropertyAmenitySlug2["Beach"] = "beach";
  PropertyAmenitySlug2["Lake"] = "lake";
  PropertyAmenitySlug2["PrivateBalcony"] = "private_balcony";
  PropertyAmenitySlug2["OutdoorFurniture"] = "outdoor_furniture";
  PropertyAmenitySlug2["SharedBackyard"] = "shared_backyard";
  PropertyAmenitySlug2["PrivateBackyard"] = "private_backyard";
  PropertyAmenitySlug2["OutdoorDining"] = "outdoor_dining";
  PropertyAmenitySlug2["BBQGrill"] = "bbq_grill";
  PropertyAmenitySlug2["FirePit"] = "fire_pit";
  PropertyAmenitySlug2["SunLoungers"] = "sun_loungers";
  PropertyAmenitySlug2["HeatedPool"] = "heated_pool";
  PropertyAmenitySlug2["SmokeAlarm"] = "smoke_alarm";
  PropertyAmenitySlug2["CarbonMonoxideAlarm"] = "carbon_monoxide_alarm";
  PropertyAmenitySlug2["FireExtinguisher"] = "fire_extinguisher";
  PropertyAmenitySlug2["FirstAidKit"] = "first_aid_kit";
  PropertyAmenitySlug2["CornerGuards"] = "corner_guards";
  PropertyAmenitySlug2["SecureLocks"] = "secure_locks";
  PropertyAmenitySlug2["BalconyRailings"] = "balcony_railings";
  PropertyAmenitySlug2["WindowGuards"] = "window_guards";
  PropertyAmenitySlug2["ExteriorSecurityCameras"] = "exterior_security_cameras";
  PropertyAmenitySlug2["PoolSafetyBarrier"] = "pool_safety_barrier";
  PropertyAmenitySlug2["StairGates"] = "stair_gates";
  PropertyAmenitySlug2["OutdoorSecurityLighting"] = "outdoor_security_lighting";
  PropertyAmenitySlug2["GasLeakDetector"] = "gas_leak_detector";
  PropertyAmenitySlug2["FireBlanket"] = "fire_blanket";
  PropertyAmenitySlug2["EmergencyLighting"] = "emergency_lighting";
  PropertyAmenitySlug2["ChildCrib"] = "child_crib";
  PropertyAmenitySlug2["HighChair"] = "high_chair";
  PropertyAmenitySlug2["BabyBath"] = "baby_bath";
  PropertyAmenitySlug2["ChildrensDinnerware"] = "childrens_dinnerware";
  PropertyAmenitySlug2["HairDryer"] = "hair_dryer";
  PropertyAmenitySlug2["Shampoo"] = "shampoo";
  PropertyAmenitySlug2["CleaningProducts"] = "cleaning_products";
  PropertyAmenitySlug2["BodySoap"] = "body_soap";
  PropertyAmenitySlug2["ShowerGel"] = "shower_gel";
  PropertyAmenitySlug2["HotWater"] = "hot_water";
  PropertyAmenitySlug2["Bathtub"] = "bathtub";
  PropertyAmenitySlug2["Jacuzzi"] = "jacuzzi";
  PropertyAmenitySlug2["Bidet"] = "bidet";
  PropertyAmenitySlug2["Towels"] = "towels";
  PropertyAmenitySlug2["Hangers"] = "hangers";
  PropertyAmenitySlug2["BedLinens"] = "bed_linens";
  PropertyAmenitySlug2["ExtraBedding"] = "extra_bedding";
  PropertyAmenitySlug2["DarkeningShades"] = "darkening_shades";
  PropertyAmenitySlug2["Iron"] = "iron";
  PropertyAmenitySlug2["DryingRack"] = "drying_rack";
  PropertyAmenitySlug2["Wardrobe"] = "wardrobe";
  PropertyAmenitySlug2["Microwave"] = "microwave";
  PropertyAmenitySlug2["CoffeeMaker"] = "coffee_maker";
  PropertyAmenitySlug2["Refrigerator"] = "refrigerator";
  PropertyAmenitySlug2["CookingBasics"] = "cooking_basics";
  PropertyAmenitySlug2["Silverware"] = "silverware";
  PropertyAmenitySlug2["Freezer"] = "freezer";
  PropertyAmenitySlug2["InductionStove"] = "induction_stove";
  PropertyAmenitySlug2["Oven"] = "oven";
  PropertyAmenitySlug2["WaterKettle"] = "water_kettle";
  PropertyAmenitySlug2["Toaster"] = "toaster";
  PropertyAmenitySlug2["BakingSheet"] = "baking_sheet";
  PropertyAmenitySlug2["DiningTable"] = "dining_table";
  PropertyAmenitySlug2["Blender"] = "blender";
  PropertyAmenitySlug2["Netflix"] = "netflix";
  PropertyAmenitySlug2["BluetoothSound"] = "bluetooth_sound";
  PropertyAmenitySlug2["ArcadeGames"] = "arcade_games";
  PropertyAmenitySlug2["Books"] = "books";
  PropertyAmenitySlug2["MovieTheater"] = "movie_theater";
  PropertyAmenitySlug2["TableGames"] = "table_games";
  PropertyAmenitySlug2["ExerciseEquipment"] = "exercise_equipment";
  PropertyAmenitySlug2["Piano"] = "piano";
  PropertyAmenitySlug2["WoodFireplace"] = "wood_fireplace";
  PropertyAmenitySlug2["CeilingFan"] = "ceiling_fan";
  PropertyAmenitySlug2["ElectricFireplace"] = "electric_fireplace";
  PropertyAmenitySlug2["PaidHousekeeping"] = "paid_housekeeping";
  PropertyAmenitySlug2["Restaurant"] = "restaurant";
  PropertyAmenitySlug2["Bar"] = "bar";
  PropertyAmenitySlug2["RoomService"] = "room_service";
  PropertyAmenitySlug2["FrontDesk24h"] = "front_desk_24h";
  PropertyAmenitySlug2["Elevator"] = "elevator";
  PropertyAmenitySlug2["Concierge"] = "concierge";
  PropertyAmenitySlug2["LaundryService"] = "laundry_service";
  PropertyAmenitySlug2["BusinessCentre"] = "business_centre";
  PropertyAmenitySlug2["MeetingRooms"] = "meeting_rooms";
  PropertyAmenitySlug2["Spa"] = "spa";
  PropertyAmenitySlug2["Sauna"] = "sauna";
  PropertyAmenitySlug2["Casino"] = "casino";
  PropertyAmenitySlug2["KidsClub"] = "kids_club";
  PropertyAmenitySlug2["AirportShuttle"] = "airport_shuttle";
  PropertyAmenitySlug2["BreakfastAvailable"] = "breakfast_available";
  PropertyAmenitySlug2["EvCharging"] = "ev_charging";
  PropertyAmenitySlug2["WheelchairAccessible"] = "wheelchair_accessible";
  PropertyAmenitySlug2["TourDesk"] = "tour_desk";
  PropertyAmenitySlug2["Garden"] = "garden";
  PropertyAmenitySlug2["Rooftop"] = "rooftop";
  PropertyAmenitySlug2["Terrace"] = "terrace";
  PropertyAmenitySlug2["CctvCommonAreas"] = "cctv_common_areas";
  PropertyAmenitySlug2["Security24h"] = "security_24h";
  PropertyAmenitySlug2["KeyCardAccess"] = "key_card_access";
  PropertyAmenitySlug2["Kitchenette"] = "kitchenette";
  PropertyAmenitySlug2["PrivateEntrance"] = "private_entrance";
  PropertyAmenitySlug2["Minibar"] = "minibar";
  PropertyAmenitySlug2["Bathrobe"] = "bathrobe";
  PropertyAmenitySlug2["Slippers"] = "slippers";
  PropertyAmenitySlug2["Soundproofing"] = "soundproofing";
  PropertyAmenitySlug2["Telephone"] = "telephone";
  PropertyAmenitySlug2["InterconnectingRooms"] = "interconnecting_rooms";
  PropertyAmenitySlug2["SofaBed"] = "sofa_bed";
  PropertyAmenitySlug2["MosquitoNet"] = "mosquito_net";
  return PropertyAmenitySlug2;
})(PropertyAmenitySlug || {});
var PROPERTY_AMENITY_CATEGORY_ORDER = [
  "amenities",
  "features",
  "essentials",
  "safety"
];

export {
  PropertyAmenitySlug,
  PROPERTY_AMENITY_CATEGORY_ORDER
};
